import React from 'react'

import { Notice } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function SuggestedSearchNotice({ suggestedTerm = null, originalTerm = null, onSearchOriginal, locale = 'en' }) {
  if (!suggestedTerm || !originalTerm) {
    return null
  }

  const showingResultsFor = i18n.t('listingPage.suggestedSearch.showingResultsFor', { ns: 'rails', lng: locale })
  const ifYouMeant = i18n.t('listingPage.suggestedSearch.ifYouMeant', { ns: 'rails', lng: locale })
  const tryThatSearchInstead = i18n.t('listingPage.suggestedSearch.tryThatSearchInstead', { ns: 'rails', lng: locale })

  return (
    <Notice type="primary" useSSRIcon className="cgt-mb-20">
      <div>
        {showingResultsFor} "<strong className="suggested-search-notice__term">{suggestedTerm}</strong>".{' '}
        {ifYouMeant}{' '}
        <span className="suggested-search-notice__link" onClick={onSearchOriginal} role="button" tabIndex={0}>
          "<strong className="suggested-search-notice__original-term">{originalTerm}</strong>"
        </span>
        , {tryThatSearchInstead}.
      </div>
    </Notice>
  )
}

SuggestedSearchNotice.propTypes = {
  suggestedTerm: string,
  originalTerm: string,
  onSearchOriginal: func.isRequired,
  locale: string,
}

export default SuggestedSearchNotice
